module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAA1klEQVR4Xu2awQ2DQBAD7eJASHzDI/TIn3ZIHRGOQOKVEjzXwVr2eE9aq/y5fH4hAA4oV4AIlBsACBIBIlCugIfhtdmaElfFwU4S7ZcAp901/GP6SwKP45LmFCAADiACMAAI0gLFClCD1CA1WF6DmZdvMQPlzDigexHCAUQABsAAarBYAfYAapAapAbLP0PHWr4HIAAOIALFi6AcGAADYAAMKFYACNICx/uUOs/kpMT5rJuiSUrVoaTkyNrLhv6nPQIUN+A9Og7AAeUKEIFyAwBBItAegR/q8nyR9OBufgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/languageflags/de.png
// module id = 173
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22